/* Tysk katalog for locale-autopilot-customers.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'ap.customerFollowup.title': 'Kundenbetreuung',
  'ap.customerFollowup.waiting': 'Wartet auf Antwort',
  'ap.customerFollowup.ready': 'Bereit für ein Angebot',
  'ap.customerFollowup.document': 'Angebot oder Auftrag zur Nachverfolgung',
  'ap.customerFollowup.openChat': 'Chat öffnen',
  'ap.customerFollowup.empty': 'Derzeit müssen keine Kunden nachverfolgt werden.',
});
